import {
  FaAngleDoubleLeft,
  FaAngleDoubleRight,
  FaChevronLeft,
  FaChevronRight,
} from "react-icons/fa";
import { FormattedMessage } from "react-intl";
import OutlinedButton from "../../../ui/OutlinedButton/OutlinedButton";

//style & scss
import classes from "./../Table.module.scss";
import { useState } from "react";
interface IPaginationProps {
  messages: any;
  gotoPage: Function;
  previousPage: Function;
  setPageSize: Function;
  nextPage: Function;
  canPreviousPage: boolean;
  canNextPage: boolean;
  pageIndex: number;
  pageSize: number;
  pageOptions: any;
  pageCount: number;
  rowsChangeable: any;
  onCheckboxChange?: any;
  selectedFlatRows?: any;
  showCTAButton?: boolean;
  toggleAllRowsSelected: any;
  showWhiteAndBlack?: boolean;
}

const Pagination = (props: IPaginationProps) => {
  const {
    messages,
    gotoPage,
    previousPage,
    canPreviousPage,
    pageIndex,
    pageOptions,
    canNextPage,
    nextPage,
    setPageSize,
    pageCount,
    pageSize,
    rowsChangeable,
    onCheckboxChange,
    selectedFlatRows,
    showCTAButton = false,
    toggleAllRowsSelected,
    showWhiteAndBlack = false,
  } = props;
  const [page, setPage] = useState<number>(pageIndex + 1);
  return (
    <div>
      {onCheckboxChange && showCTAButton && showWhiteAndBlack && (
        <div className={classes["update-list-button-wrapper"]}>
          <OutlinedButton
            onClick={() => {
              onCheckboxChange(selectedFlatRows, true);
              toggleAllRowsSelected(false);
            }}
          >
            <FormattedMessage {...messages.CTAWhite} />
          </OutlinedButton>

          <OutlinedButton
            onClick={() => {
              onCheckboxChange(selectedFlatRows, false);
              toggleAllRowsSelected(false);
            }}
          >
            <FormattedMessage {...messages.CTABlack} />
          </OutlinedButton>
        </div>
      )}
      {onCheckboxChange && showCTAButton && !showWhiteAndBlack && (
        <div className={classes["update-list-button-wrapper"]}>
          <OutlinedButton
            onClick={() => {
              onCheckboxChange(selectedFlatRows);
              toggleAllRowsSelected(false);
            }}
          >
            <FormattedMessage {...messages.CTAUpdateListButton} />
          </OutlinedButton>
        </div>
      )}
      <div className={classes["pagination-wrapper"]}>
        <button
          className={classes.button}
          // type="submit"
          onClick={(e) => {
            // e.preventDefault();
            gotoPage(0);
          }}
          disabled={!canPreviousPage}
        >
          {<FaAngleDoubleLeft className={classes.icon} />}
        </button>
        <button
          className={classes.button}
          onClick={() => previousPage()}
          disabled={!canPreviousPage}
        >
          {<FaChevronLeft className={classes.icon} />}
        </button>
        <span className={classes.text}>
          <FormattedMessage {...messages.Page} />
          <strong className={classes.text}>
            {pageIndex + 1} <FormattedMessage {...messages.Of} />{" "}
            {pageOptions.length}
          </strong>
        </span>
        <button
          className={classes.button}
          onClick={() => nextPage()}
          disabled={!canNextPage}
        >
          {<FaChevronRight className={classes.icon} />}
        </button>
        <button
          className={classes.button}
          onClick={() => gotoPage(pageCount - 1)}
          disabled={!canNextPage}
        >
          {<FaAngleDoubleRight className={classes.icon} />}
        </button>
        <span className={classes.text}>
          <FormattedMessage {...messages.GoToPage} />
          <form
            style={{
              display: "inline",
            }}
            onSubmit={(e) => {
              e.preventDefault();
              gotoPage(page - 1);
            }}
          >
            <input
              className={classes["box-input"]}
              type="number"
              max={pageCount}
              value={page}
              onChange={(e) => {
                // if (e.target.value.match(/[0-9]/g)) {
                const page = e.target.value;
                setPage(Number(page));
                // }
              }}
            />
            <button type="submit" style={{ display: "none" }} />
          </form>
        </span>
        {rowsChangeable && (
          <select
            className={classes["box-select"]}
            value={pageSize}
            onChange={(e) => {
              setPageSize(Number(e.target.value));
            }}
          >
            {[5, 10, 20, 30, 40, 50].map((pageSize, i) => (
              <FormattedMessage
                key={`pagination-table-id-${i}`}
                {...messages.Show}
              >
                {(mess) => (
                  <option key={pageSize} value={pageSize}>
                    {" "}
                    {mess}/{pageSize}{" "}
                  </option>
                )}
              </FormattedMessage>
            ))}
          </select>
        )}
      </div>
    </div>
  );
};

export default Pagination;
